import {
  LIST_CHANNEL_PLATFORMS_ROUTE,
  LIST_CHANNEL_INSTALLATIONS_ROUTE,
  CONNECT_CHANNEL_ROUTE,
  DISCONNECT_CHANNEL_ROUTE,
} from '../../handlers/channels';

export const CHANNELS_ROUTES = [
  LIST_CHANNEL_PLATFORMS_ROUTE,
  LIST_CHANNEL_INSTALLATIONS_ROUTE,
  CONNECT_CHANNEL_ROUTE,
  DISCONNECT_CHANNEL_ROUTE,
] as const;
